import React from 'react';
import styled from '@emotion/styled';
import theme from '../../themes/default';
import Button from '../Button/Button';

const commonButtonStyle = `
  font-size: ${theme.font.size.copy};
  font-weight: ${theme.font.weight.semiBold};
  font-family: ${theme.font.family.workSans};
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.medium} ${theme.spacing.small};
`;

const DialogButton = styled(Button)`
  line-height: ${theme.font.lineHeight.small};
  margin: 0px;
`;

export const PrimaryButton = styled(({ danger, children, ...props }) => (
  <DialogButton size="small" type="primary" {...props}>
    {children}
  </DialogButton>
))`
  ${commonButtonStyle};
  background-color: ${(props) =>
    props.danger ? theme.color.red : theme.color.designSystem.purple70};
  :hover {
    background-color: ${(props) =>
      `${props.danger ? theme.color.red : theme.color.designSystem.purple60}`};
  }
  :disabled {
    color: ${theme.color.designSystem.blackOpacity38};
    background-color: ${(props) =>
      `${props.danger ? theme.color.red : theme.color.blackAlpha(0.12)}`};
  }

  && {
    margin-left: ${theme.spacing.medium};
  }
`;

export const SecondaryButton = styled((props) => (
  <DialogButton size="small" type="secondary" {...props} />
))`
  ${commonButtonStyle};
  color: ${theme.color.designSystem.purple70};
  border: 1px solid ${theme.color.designSystem.blackOpacity38};
  background: transparent;
  margin-left: auto;
  :disabled {
    border: 1px solid ${theme.color.designSystem.blackOpacity38};
    color: ${theme.color.designSystem.blackOpacity38};
    background: transparent;
  }
`;

export const TextButton = styled('span')`
  color: ${theme.color.designSystem.purple70};
  line-height: ${theme.font.lineHeight.copy};
  ${(props) => props.tertiary && 'margin-right: auto;'};
  ${(props) => props.primary && 'margin-left: 24px;'};
  cursor: pointer;
`;
